import { IRootState } from '../../../store'
import { ICadImportState } from '../store/cadImport.types'

export const getCadImportSelector = (state: IRootState): ICadImportState => state.cadImport
